export {
  isWebKit,
  isMac,
  isIPhone,
  isIPad,
  isIOS,
  isAppleDevice,
  isChrome,
  isAndroid,
  isFirefox
} from '../../../src/utils/platform';
